import React, { useEffect, useRef, useState } from "react";

const Dropdown = ({ label, value, options, onChange }) => {
  const [open, setOpen] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="a11y-dropdown-wrapper">
      <label className="a11y-dropdown-label">{label}</label>

      <div ref={dropdownRef} className="a11y-dropdown">
        <button
          type="button"
          className={`a11y-dropdown-btn ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
        >
          <span>{value}</span>

          <svg
            className={`a11y-chevron ${open ? "rotate" : ""}`}
            width="18"
            height="18"
            viewBox="0 0 24 24"
          >
            <path fill="currentColor" d="M7 10l5 5 5-5" />
          </svg>
        </button>

        {open && (
          <div className="a11y-dropdown-menu">
            {options.map((option) => (
              <button
                key={option}
                className={`a11y-dropdown-item ${
                  value === option ? "selected" : ""
                }`}
                onClick={() => {
                  onChange(option);
                  setOpen(false);
                }}
              >
                {option}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropdown;
